const View = ({}: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5642 13.9121V19.9298C19.5642 20.2298 19.4417 20.5023 19.2445 20.6996C19.0472 20.8968 18.7747 21.0193 18.4748 21.0193H5.52499C5.22501 21.0193 4.95255 20.8968 4.75528 20.6996C4.55801 20.5023 4.43555 20.2298 4.43555 19.9298V13.9121H5.18557V19.9298C5.18557 20.0228 5.22388 20.1076 5.28555 20.1693C5.34724 20.231 5.43203 20.2693 5.52499 20.2693H18.4748C18.5677 20.2693 18.6525 20.231 18.7142 20.1693C18.7759 20.1076 18.8142 20.0228 18.8142 19.9298V13.9121H19.5642H19.5642Z"
        fill="white"
      />
      <path
        d="M18.8142 12.4112V11.5894C18.8142 11.5006 18.7739 11.4189 18.7089 11.3588C18.6364 11.2917 18.5332 11.25 18.4169 11.25H5.58285C5.4666 11.25 5.36341 11.2917 5.29086 11.3588C5.22591 11.4189 5.18557 11.5006 5.18557 11.5894V12.4112H4.43555V11.5894C4.43555 11.2854 4.56903 11.0098 4.78402 10.811C4.99142 10.6191 5.27441 10.5 5.58284 10.5H18.4169C18.7254 10.5 19.0084 10.6191 19.2157 10.811C19.4307 11.0098 19.5642 11.2853 19.5642 11.5894V12.4112H18.8142H18.8142Z"
        fill="white"
      />
      <path
        d="M3.2378 12.7871C3.0307 12.7871 2.86279 12.955 2.86279 13.1621C2.86279 13.3692 3.0307 13.5371 3.2378 13.5371H20.7618C20.9689 13.5371 21.1368 13.3692 21.1368 13.1621C21.1368 12.955 20.9689 12.7871 20.7618 12.7871H3.2378Z"
        fill="white"
      />
      <path
        d="M21.1367 13.1621C21.1367 12.955 20.9688 12.7871 20.7617 12.7871C20.5546 12.7871 20.3867 12.955 20.3867 13.1621V14.4092C20.3867 14.6163 20.5546 14.7842 20.7617 14.7842C20.9688 14.7842 21.1367 14.6163 21.1367 14.4092V13.1621Z"
        fill="white"
      />
      <path
        d="M3.6133 13.1621C3.6133 12.955 3.44539 12.7871 3.23829 12.7871C3.03119 12.7871 2.86328 12.955 2.86328 13.1621V14.4092C2.86328 14.6163 3.03119 14.7842 3.23829 14.7842C3.44539 14.7842 3.6133 14.6163 3.6133 14.4092V13.1621Z"
        fill="white"
      />
      <path
        d="M9.87794 10.125C9.99093 9.80535 10.1741 9.51886 10.4089 9.28404C10.8161 8.87685 11.3786 8.625 11.9999 8.625C12.6211 8.625 13.1837 8.87685 13.5908 9.28404C13.8257 9.51886 14.0088 9.80535 14.1218 10.125H13.2992C13.2333 10.0111 13.1529 9.90671 13.0606 9.81432C12.7891 9.54291 12.4141 9.37502 11.9999 9.37502C11.5856 9.37502 11.2106 9.54291 10.9392 9.81432C10.8468 9.90671 10.7664 10.0111 10.7005 10.125H9.87793H9.87794Z"
        fill="white"
      />
      <path
        d="M14.1204 3.94015C14.1794 3.85562 14.1588 3.73919 14.0742 3.68015C13.9897 3.6211 13.8733 3.64175 13.8142 3.72628C13.2034 4.60127 13.5107 5.26564 13.7985 5.88797C14.0206 6.36796 14.2287 6.81791 13.837 7.30137C13.7719 7.38145 13.784 7.49918 13.8641 7.56429C13.9442 7.6294 14.0619 7.61727 14.127 7.53719C14.666 6.87192 14.4107 6.32 14.1384 5.73124C13.8939 5.20266 13.6329 4.63839 14.1204 3.94015V3.94015Z"
        fill="white"
      />
      <path
        d="M12.2468 3.19796C12.3059 3.11344 12.2852 2.997 12.2007 2.93796C12.1162 2.87891 11.9997 2.89956 11.9407 2.98409C11.3298 3.8591 11.6371 4.52344 11.925 5.1458C12.147 5.62577 12.3551 6.07573 11.9634 6.55918C11.8983 6.63927 11.9104 6.757 11.9905 6.82211C12.0706 6.88722 12.1883 6.87509 12.2534 6.79501C12.7925 6.12974 12.5372 5.57783 12.2649 4.98907C12.0204 4.46048 11.7594 3.89622 12.2468 3.19796Z"
        fill="white"
      />
      <path
        d="M10.616 4.26632C10.675 4.1818 10.6544 4.06536 10.5698 4.00632C10.4853 3.94727 10.3689 3.96792 10.3098 4.05245C9.69897 4.92746 10.0063 5.59182 10.2941 6.21416C10.5162 6.69413 10.7243 7.14409 10.3326 7.62754C10.2675 7.70763 10.2796 7.82536 10.3597 7.89047C10.4398 7.95557 10.5575 7.94345 10.6226 7.86337C11.1616 7.1981 10.9063 6.64618 10.634 6.05743C10.3895 5.52885 10.1285 4.96458 10.616 4.26632Z"
        fill="white"
      />
    </svg>
  );
};
export default View;
